import * as actionTypes from "../actions/actionTypes";
import { UserIdQueryType, CrowdEventLogFilter } from "../../components/Utils/Models/api";

export const initialState: CrowdEventLogFilter = {
  userIds: "",
  userIdQueryType: UserIdQueryType.And,
  pageNumber: 1,
  pageSize: 10,
};

const setCrowdFilter_Reducer = (state: CrowdEventLogFilter, action: any) => {
  return {
    ...state,
    ...action.filter,
  };
};

const reducer = (state = initialState, action: any) => {
  switch (action.type) {
    case actionTypes.SET_CROWD_FILTER:
      return setCrowdFilter_Reducer(state, action);
    default:
      return state;
  }
};
export default reducer;
